<script>
    export let button;
    function openLink() {
        if (button.title !== "Coming soon") {
            window.open(button.link);
        }
    }
</script>

<button on:click={openLink}>{button.title} -></button>

<style>
    button {
        background-color: rgba(160, 200, 255, 0.8);
        border: 3px solid rgba(0, 0, 0, 0.9);
        padding: 12px 24px;
        color: rgba(0, 0, 0, 0.9);
        font-weight: bold;
        font-size: 16px;
        border-radius: 8px;
        border-radius: 8px;
        margin-right: 12px;
        cursor: pointer;
        margin-top: 24px;
        margin-bottom: 24px;
        transition: 0.2s ease;
    }
    button:hover {
        scale: 1.1;
    }

</style>